import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=b6b0e236"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"
import style0 from "./Code.vue?vue&type=style&index=0&id=b6b0e236&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports